import {
  autoPlacement,
  offset,
  Placement,
  useFloating,
  useHover,
  useInteractions,
} from "@floating-ui/react";
import React, { useState } from "react";
import { FilterState } from "../../adapters/insights-agent/state/AppState.ts";
import { makeChipValues } from "../FilterChips/makeChipValues.ts";
import styles from "./AppliedFilters.module.css";
import { motion } from "motion/react";

export const AppliedFilters: React.FC<{
  appliedFilter: FilterState;
  placement?: Placement;
}> = (props) => {
  const chipValue = makeChipValues(props.appliedFilter);

  const [isOpen, setIsOpen] = useState(false);

  const { refs, floatingStyles, context } = useFloating({
    open: isOpen,
    onOpenChange: setIsOpen,
    placement: props.placement || "right-start",
    middleware: [autoPlacement(), offset(10)],
  });
  const { getReferenceProps, getFloatingProps } = useInteractions([
    useHover(context),
  ]);

  if (chipValue.length === 0) return null;
  return (
    <>
      <div
        ref={refs.setReference}
        {...getReferenceProps()}
        className={styles.AppliedFilters}
      >
        {chipValue.length} applied filters
      </div>
      {isOpen && (
        <div
          ref={refs.setFloating}
          style={floatingStyles}
          {...getFloatingProps()}
        >
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2 }}
            className={styles.FilterList}
          >
            Applied filters:
            <motion.ul
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.2 }}
            >
              {chipValue.map((chip, index) => (
                <li key={index}>{chip.label}</li>
              ))}
            </motion.ul>
          </motion.div>
        </div>
      )}
    </>
  );
};
